import * as React from 'react';
import * as style from './style.css';
import { UIHeading3, UIText1 } from '@cian/ui-kit';

export const EmptyContent = () => {
  return (
    <div className={style['container']}>
      <UIHeading3>По такому запросу нет данных</UIHeading3>
      <div className={style['description']}>
        <UIText1 color="current_color">Попробуйте что-то изменить в фильтрах</UIText1>
      </div>
    </div>
  );
};
